module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "post"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    staticClass: "title",
    attrs: {
      "required": "",
      "placeholder": "标题...（不少于十个字）"
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.article.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.tab),
      expression: "article.tab"
    }],
    staticClass: "select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.article.tab = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("选择...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "share"
    }
  }, [_vm._v("分享")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ask"
    }
  }, [_vm._v("问答")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "job"
    }
  }, [_vm._v("招聘")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.content),
      expression: "article.content"
    }],
    staticClass: "post_detail",
    attrs: {
      "placeholder": "内容..."
    },
    domProps: {
      "value": (_vm.article.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.article.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "click"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fec500d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Post.vue
// module id = 147
// module chunks = 1